import React from 'react';
import AlertMessage from '../AlertMessage';

/**
 * Displays a notice that the current order is for Medicare/Tricare
 */
export default function MedicareOrderAlert() {
	return (
		<AlertMessage type="info">
			<div className="small">
				<span>
					This order is being placed for a Medicare or Tricare patient. 
				</span>
				<div>
					<a
						href="/files/medicare/Notification-to-Physicians-Regarding-Medicare-Tests.pdf"
						target="_blank"
						title="Notification to Physicians Regarding Medicare Tests"
					>
						<span className="fa fa-external-link pe-1"></span>
						View Important Information Regarding Medicare
					</a>
				</div>
			</div>
		</AlertMessage>
	);
}
